import React from 'react';
import { Link } from 'react-router-dom';
import Logo, { LogoLight } from '../../../components/Sidebar/Logo';
import { useTheme } from '../../../context/ThemeContext';
import './StaticHeader.scss';

const StaticHeader = ({ variant = 'default' }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark' || theme === 'system';

  // Different navigation variants for different pages
  const getNavLinks = () => {
    if (variant === 'home') {
      return (
        <>
          <a href="#features">Features</a>
          <a href="#how-it-works">How it Works</a>
          <a href="#pricing">Pricing</a>
          <Link to="/dealmirror" className="nav-black-friday">🔥 Special Lifetime Deal</Link>
          <a href="#testimonials">Testimonials</a>
        </>
      );
    }

    // Default variant for other pages
    return (
      <>
        <Link to="/">Home</Link>
        <Link to="/features-comparison">Features</Link>
        <Link to="/roadmap">Roadmap</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/changelog">Changelog</Link>
      </>
    );
  };

  console.log('Current theme:', theme);


  return (
    <nav className="landing-nav">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          {isDark ? <Logo width="120px" /> : <LogoLight width="120px" />}
        </Link>
        <div className="nav-links">
          {getNavLinks()}
        </div>
        <div className="nav-actions">
          <Link to="/login" className="nav-login">Log In</Link>
          <Link to="/signup" className="nav-signup">Get Started Free</Link>
        </div>
      </div>
    </nav>
  );
};

export default StaticHeader;

